import { takeEvery, put, call } from "redux-saga/effects";
import apiCall from "../services";

const apiUrl = process.env.REACT_APP_API_URL;
const enviromentUrl = process.env.REACT_APP_ENVIROMENT;

const getSetCookie = () => {
  return window.localStorage.getItem("uuidSetCookie");
};

function* getCustomQuestionList(actions) {
  const uuid = getSetCookie();

  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-custom-checkout-questions?page=" + actions.page
        : apiUrl + "/opa-custom-checkout-questions" + actions.query;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);
    yield put({ type: "LIST_CUSTOM_QUESTION_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "LIST_CUSTOM_QUESTION_RESPONSE_GET", value: error });
  }
}

function* getCustomQuestion(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = `${apiUrl}/opa-custom-checkout-question/${actions.query}?include=products`;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({ type: "CUSTOM_QUESTION_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "CUSTOM_QUESTION_RESPONSE_GET", value: error });
  }
}

function* resetCustomQuestion() {
  yield put({ type: "CUSTOM_QUESTION_RESPONSE_RESET" });
}

function* addCustomQuestion(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-custom-checkout-question";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.createdAt || response.uuid) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "CUSTOM_QUESTION_RESPONSE_ADD",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "CUSTOM_QUESTION_RESPONSE_ADD",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}

function* updateCustomQuestion(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const formData = { ...actions.form };

    if (formData.uuid) {
      delete formData.uuid;
    }

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(formData),
    };

    let url = `${apiUrl}/opa-custom-checkout-question/${actions.questionUuid}`;

    if (enviromentUrl !== "") {
      url += url.includes("?")
        ? `&env=${enviromentUrl}`
        : `?env=${enviromentUrl}`;
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.updatedAt || response.uuid) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "CUSTOM_QUESTION_RESPONSE_UPDATE",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "CUSTOM_QUESTION_RESPONSE_UPDATE",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}

function* deleteCustomQuestion(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = apiUrl + "/opa-custom-checkout-question/" + actions.questionUuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.status == 200 || response.status == 204) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "CUSTOM_QUESTION_RESPONSE_DELETE",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "CUSTOM_QUESTION_RESPONSE_DELETE",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* addCustomQuestionProduct(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    if (!actions.form || !actions.form.questionFormData) {
      yield put({
        type: "CUSTOM_QUESTION_PRODUCT_RESPONSE_ADD",
        value: {
          error: "Missing question UUID",
          responseStatus: "error",
        },
      });
      return;
    }

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form.questionFormData),
    };

    let url =
      apiUrl +
      "/opa-custom-checkout-question/" +
      actions.form.questionUuid +
      "/products";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (Array.isArray(response) || response.success) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "CUSTOM_QUESTION_PRODUCT_RESPONSE_ADD",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "CUSTOM_QUESTION_PRODUCT_RESPONSE_ADD",
      value: {
        error: error.message || "Unknown error",
        responseStatus: "error",
      },
    });
  }
}

function* deleteCustomQuestionProducts(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.payload.questionFormData),
    };

    let url =
      apiUrl +
      "/opa-custom-checkout-question/" +
      actions.payload.questionUuid +
      "/products";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.status == 200 || response.status == 204) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "CUSTOM_QUESTION_PRODUCTS_RESPONSE_DELETE",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "CUSTOM_QUESTION_PRODUCTS_RESPONSE_DELETE",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* getCustomQuestionProducts(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = `${apiUrl}/opa-custom-checkout-question/${actions.questionUuid}`;
    if (enviromentUrl !== "") {
      url += `?env=${enviromentUrl}`;
    }

    const questionResponse = yield call(apiCall, "get", url, requestOptions);

    if (
      questionResponse &&
      questionResponse.products &&
      Array.isArray(questionResponse.products) &&
      questionResponse.products.length > 0
    ) {
      yield put({
        type: "CUSTOM_QUESTION_PRODUCTS_RESPONSE_GET",
        value: questionResponse.products,
      });
    } else {
      yield put({ type: "CUSTOM_QUESTION_PRODUCTS_RESPONSE_GET", value: [] });
    }
  } catch (error) {
    yield put({ type: "CUSTOM_QUESTION_PRODUCTS_RESPONSE_GET", value: [] });
  }
}

function* getProductCustomQuestion(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url;
    if (actions.questionUuid) {
      url = `${apiUrl}/opa-product-custom-question/${actions.productUuid}/${actions.questionUuid}`;
    } else {
      url = `${apiUrl}/opa-product-custom-question/${actions.productUuid}`;
    }

    if (enviromentUrl !== "") {
      url += url.includes("?")
        ? `&env=${enviromentUrl}`
        : `?env=${enviromentUrl}`;
    }

    const response = yield call(apiCall, "get", url, requestOptions);
    yield put({
      type: "PRODUCT_CUSTOM_QUESTION_RESPONSE_GET",
      value: response,
    });
  } catch (error) {
    yield put({ type: "PRODUCT_CUSTOM_QUESTION_RESPONSE_GET", value: error });
  }
}

function* addCustomQuestionsProduct(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form.customQuestionUuids),
    };

    let url =
      apiUrl +
      "/opa-product-custom-checkout-questions/" +
      actions.form.productUuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (Array.isArray(response) || response.success) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "CUSTOM_QUESTIONS_PRODUCT_RESPONSE_ADD",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "CUSTOM_QUESTIONS_PRODUCT_RESPONSE_ADD",
      value: {
        error: error.message || "Unknown error",
        responseStatus: "error",
      },
    });
  }
}

function* deleteCustomQuestionsProduct(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form.customQuestionUuids),
    };

    let url = apiUrl + "/opa-product-custom-checkout-questions/" + actions.form.productUuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.status == 200 || response.status == 204) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "CUSTOM_QUESTIONS_PRODUCT_RESPONSE_DELETE",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "CUSTOM_QUESTIONS_PRODUCT_RESPONSE_DELETE",
      value: {
        error: error.message || "Unknown error",
        responseStatus: "error",
      },
    });
  }
}

export function* getSagaCustomQuestionList() {
  yield takeEvery("GET_LIST_CUSTOM_QUESTIONS", getCustomQuestionList);
}

export function* getSagaCustomQuestion() {
  yield takeEvery("GET_CUSTOM_QUESTION", getCustomQuestion);
}

export function* resetSagaCustomQuestion() {
  yield takeEvery("RESET_CUSTOM_QUESTION", resetCustomQuestion);
}

export function* addSagaCustomQuestion() {
  yield takeEvery("ADD_CUSTOM_QUESTION", addCustomQuestion);
}

export function* updateSagaCustomQuestion() {
  yield takeEvery("UPDATE_CUSTOM_QUESTION", updateCustomQuestion);
}

export function* deleteSagaCustomQuestion() {
  yield takeEvery("DELETE_CUSTOM_QUESTION", deleteCustomQuestion);
}

export function* addSagaCustomQuestionProduct() {
  yield takeEvery("ADD_CUSTOM_QUESTION_PRODUCT", addCustomQuestionProduct);
}

export function* deleteSagaCustomQuestionProducts() {
  yield takeEvery("DELETE_CUSTOM_QUESTION_PRODUCTS", deleteCustomQuestionProducts);
}

export function* getSagaCustomQuestionProducts() {
  yield takeEvery("GET_CUSTOM_QUESTION_PRODUCTS", getCustomQuestionProducts);
}

export function* getSagaProductCustomQuestion() {
  yield takeEvery("GET_PRODUCT_CUSTOM_QUESTION", getProductCustomQuestion);
}

export function* addSagaCustomQuestionsProduct() {
  yield takeEvery("ADD_CUSTOM_QUESTIONS_PRODUCT", addCustomQuestionsProduct);
}

export function* deleteSagaCustomQuestionsProduct() {
  yield takeEvery("DELETE_CUSTOM_QUESTIONS_PRODUCT", deleteCustomQuestionsProduct);
}
